export default "__VITE_ASSET__CQ9WkIk1__"